import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3524d2da&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./TreatmentStepTwoForms.styles.scss?vue&type=style&index=0&id=3524d2da&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524d2da",
  null
  
)

export default component.exports